// /admin/credits* CRUD-Wrapper — alle Endpoints Owner-only (siehe api/src/routes/admin.ts).
// Deckt ab: Credit-Grant/Deduct pro User, Feature-Preis-Tabelle, Credit-Packs.

import { apiFetch } from './api';

// ── Grant / Deduct ────────────────────────────────────────────────────────

export interface AdjustCreditsInput {
  /** Positiv = Gutschrift, negativ = Abzug (serverseitig auf 0 geclampt). */
  amount: number;
  note?: string;
}

export interface AdjustCreditsResponse {
  balance: number;
}

export async function adjustUserCredits(
  accessToken: string,
  userId: string,
  input: AdjustCreditsInput,
): Promise<AdjustCreditsResponse> {
  return apiFetch<AdjustCreditsResponse>(`/admin/users/${userId}/credits`, {
    method: 'POST',
    accessToken,
    json: input,
  });
}

// ── Feature-Preise ────────────────────────────────────────────────────────

export type FeatureUnit = 'action' | 'day';
export type FeatureCategory = 'llm' | 'background';

export interface FeatureCostRow {
  feature: string;
  credits: number;
  unit: FeatureUnit;
  category: FeatureCategory;
  label: string;
  updated_at: string | null;
}

export async function listFeatureCosts(accessToken: string): Promise<FeatureCostRow[]> {
  return apiFetch<FeatureCostRow[]>('/admin/feature-costs', { accessToken });
}

export interface UpdateFeatureCostInput {
  credits: number;
  unit?: FeatureUnit;
  category?: FeatureCategory;
  label?: string;
}

export async function updateFeatureCost(
  accessToken: string,
  feature: string,
  input: UpdateFeatureCostInput,
): Promise<FeatureCostRow> {
  return apiFetch<FeatureCostRow>(`/admin/feature-costs/${encodeURIComponent(feature)}`, {
    method: 'PUT',
    accessToken,
    json: input,
  });
}

// ── Credit-Packs ──────────────────────────────────────────────────────────

export interface CreditPackRow {
  id: string;
  label: string;
  credits: number;
  price_cents: number;
  stripe_price_id: string | null;
  /** SQLite-Integer: 1 = aktiv, 0 = inaktiv. */
  active: number;
  sort_order: number;
  updated_at: string | null;
}

export async function listCreditPacks(accessToken: string): Promise<CreditPackRow[]> {
  return apiFetch<CreditPackRow[]>('/admin/credit-packs', { accessToken });
}

export interface UpdateCreditPackInput {
  label: string;
  credits: number;
  price_cents: number;
  stripe_price_id?: string | null;
  active?: boolean;
  sort_order?: number;
}

export async function updateCreditPack(
  accessToken: string,
  id: string,
  input: UpdateCreditPackInput,
): Promise<unknown> {
  return apiFetch<unknown>(`/admin/credit-packs/${encodeURIComponent(id)}`, {
    method: 'PUT',
    accessToken,
    json: input,
  });
}
